/**
 * Der Kopf des Bestell-Drawers - Portierung von `index.html:9273-9281` (`.drawer-head`).
 *
 * Original, woertlich:
 *
 *     <div class="drawer-head">
 *       <div class="head-inputs">
 *         <input class="no-input" value="${esc(o.orderNo)}" placeholder="Bestell-Nr. (z. B. PO-2026-014)"
 *                ${hasPermission('edit_orders') ? '' : 'disabled'} oninput="patch('orderNo', this.value)">
 *         <input class="name-input" value="${esc(o.name)}" placeholder="Bezeichnung der Bestellung…"
 *                ${hasPermission('edit_orders') ? '' : 'disabled'} oninput="patch('name', this.value)">
 *       </div>
 *       <button class="icon-btn" onclick="closeDrawer()" title="Schließen">${icon('x')}</button>
 *     </div>
 *
 * ================= Die tragende Eigenheit =================
 *
 * Beide Kopffelder haengen an `edit_orders` DIREKT - NICHT am Schreibrecht des offenen Reiters.
 * Wer im Reiter "Dokumente" steht und `manage_documents` besitzt, aber kein `edit_orders`, kann
 * die Dokumente bearbeiten und die Bestellnummer trotzdem nicht. Und umgekehrt. Der Kopf liegt
 * ausserdem ausserhalb von `.drawer-body` und wird deshalb vom Rechte-Durchgang in `Drawer.tsx`
 * (`d.querySelectorAll('.drawer-body …')`, `index.html:9299`) gar nicht erst erfasst - er
 * entscheidet vollstaendig fuer sich.
 */
import { hatRecht } from "./drawerRechte.ts";
import type { Order } from "../../lib/types.ts";

/**
 * `icon(name, className)` (`index.html:4016`) samt der Nachbearbeitung durch `hydrateIcons`
 * (`:4021`) - die gemeinsame Registratur zeichnet das fertige `<svg class="lucide lucide-…">`.
 *
 * Bis `feat/09-spa-ikonen` stand hier eine LOKALE Funktion, die nur den Platzhalter
 * `<i data-lucide="…">` erzeugte. Den hydriert in der SPA niemand (die UMD-Fassung laeuft allein
 * im Baseline-Rundlauf des Playwright-Harness) - es blieb eine leere Flaeche. Siehe `Ikone.tsx`.
 */
import { Ikone } from "../Ikone.tsx";

export interface DrawerKopfProps {
  bestellung: Order;
  rechte: ReadonlySet<string>;
  /** `patch('orderNo', …)` / `patch('name', …)` (`index.html:9642`). */
  onFeld?: (feld: string, wert: string) => void;
  /** `closeDrawer()` (`index.html:9631`). */
  onSchliessen: () => void;
}

export function DrawerKopf({ bestellung, rechte, onFeld, onSchliessen }: DrawerKopfProps) {
  // `esc()` entfaellt: React maskiert Textwerte von sich aus. `?? ""`, weil ein `undefined` als
  // `value` React in den unkontrollierten Modus kippen liesse - im Original ergaebe `esc(undefined)`
  // an derselben Stelle den leeren String.
  const darfBestellungBearbeiten = hatRecht(rechte, "edit_orders");

  return (
    <div className="drawer-head">
      <div className="head-inputs">
        <input
          className="no-input"
          value={(bestellung.orderNo as string) ?? ""}
          placeholder="Bestell-Nr. (z. B. PO-2026-014)"
          disabled={!darfBestellungBearbeiten}
          onInput={(e) => onFeld?.("orderNo", e.currentTarget.value)}
          onChange={() => {}}
        />
        <input
          className="name-input"
          value={(bestellung.name as string) ?? ""}
          placeholder="Bezeichnung der Bestellung…"
          disabled={!darfBestellungBearbeiten}
          onInput={(e) => onFeld?.("name", e.currentTarget.value)}
          onChange={() => {}}
        />
      </div>
      <button className="icon-btn" onClick={onSchliessen} title="Schließen">
        <Ikone name="x" />
      </button>
    </div>
  );
}
